export default function AdminCard({ children, header, className = "" }) {
  return (
    <div className={`bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden ${className}`}>
      {header && (
        <div className="px-6 py-4 border-b border-slate-100 bg-slate-50/60">
          <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">{header}</span>
        </div>
      )}
      {children}
    </div>
  );
}
